<template>
  <slot />

  <SafeTeleport to=".tooltip-warp-zone" v-if="isVisible">
    <transition appear name="slide-fade-in">
      <div v-if="text && isVisible" class="pointer-events-none hidden md:block">
        <div
          class="tooltip-arrow absolute bg-grey-90 rounded-sm h-3 w-3"
          :class="[positionClass]"
          :style="arrowStyle"
        ></div>
        <div
          ref="overlayElement"
          class="tooltip absolute bg-grey-90 text-grey-10 text-sm rounded py-2 px-3 text-center flex flex-col gap-2"
          :class="[positionClass]"
          :style="style"
        >
          <!-- eslint-disable vue/no-v-html -->
          <!-- eslint-disable vue/no-v-text-v-html-on-component -->
          <StellaText
            v-html="text"
            is="div"
            type="Label XS"
            class="line-clamp-3 max-w-xs w-max self-center"
          />
          <StellaText
            v-if="subtext"
            v-html="subtext"
            is="div"
            type="Label XS"
            class="line-clamp-3 max-w-xs w-max self-center text-grey-30"
          />
        </div>
      </div>
    </transition>
  </SafeTeleport>
</template>

<script lang="ts" setup>
import { useOverlayApi, type Position } from '/@/core/overlay'
import { SafeTeleport } from 'vue-safe-teleport'

const {
  text,
  subtext,
  position = 'bottom',
} = defineProps<{
  text?: string
  subtext?: string
  position?: Position
}>()

const { overlayElement, isVisible, arrowStyle, style, positionClass } =
  useOverlayApi(text ?? 'empty-tooltip', { position })
</script>

<style scoped lang="scss">
.slide-fade-in-enter-active {
  opacity: 1;
  transition: opacity 150ms 400ms ease-in-out;
  > * {
    margin: 0;
    transition: margin 100ms 400ms ease-in-out;
  }
}

.slide-fade-in-enter-from,
.slide-fade-in-leave-to {
  opacity: 0 !important;

  > * {
    &.p-top {
      margin-top: 0.5rem;
    }
    &.p-bottom {
      margin-top: -0.5rem;
    }
    &.p-left {
      margin-left: 0.5rem;
    }
    &.p-right {
      margin-left: -0.5rem;
    }
  }
}
</style>
